/**
 * @title fsamodal.js: Sub-module for Global pages
 * @description This module is used to display the fsa modal
 * @dependency 
 */
define([], function() {	
	
	var rxcontactus = {
			
		init : function() {
			this.createFormValidation();
		},	 
    
		createFormValidation : function() {
			
			$('#ContactUsForm').validate({
				rules : { 
				contactEmailAddress:{ required: true,email:true },
				subjectOfQuestion  :'required',
				candidateQuery     :'required'
				},
				messages : {
					contactEmailAddress: {required :messages.ERR_CONTACT_US_REQUIRED_EMAIL, email:messages.ERR_CONTACT_US_INVALID_EMAIL},
					subjectOfQuestion  : messages.ERR_CONTACT_US_REQUIRED_SUBJECT,
					candidateQuery     : messages.ERR_CONTACT_US_REQUIRED_BODY
					
				}
			});
			
		}

	}//end rxcontactus object

	// Expose rxcontactus to the global scope.
    if (typeof window.COSTCO === "undefined") {
        window.COSTCO = new Object();
    } 
	
    window.COSTCO.rxcontactus = rxcontactus;
		
	return rxcontactus;
    
});


// WEBPACK FOOTER //
// ./js/rx/rxcontactus.js